export const adminConstants = {
    REGISTER_REQUEST: 'REGISTER_REQUEST',
    REGISTER_SUCCESS: 'REGISTER_SUCCESS',
    REGISTER_FAILURE: 'REGISTER_FAILURE',

    GET_ALL_ADMINS_REQEUST: 'GET_ALL_ADMINS_REQUEST',
    GET_ALL_ADMINS_SUCCESS: 'GET_ALL_ADMINS_SUCCESS',
    GET_ALL_ADMINS_FAILURE: 'GET_ALL_ADMINS_FAILURE'
}


// WEBPACK FOOTER //
// ./src/constants/admin.js